import { useIntl } from "react-intl";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { isEmpty } from "lodash";
import { getFunctionsLevels, getFunctionsAndLevelsThunk } from "store/slice/Project/functions/functionsSlice";
import { FunctionLevelElement } from "services/projects/project.types";
import { RequestInfo } from "store/slice/store.types";

export type TElement = {
    id: number;
    name: string;
    type?: string;
};

export const convertFunctionHierarchyValue = (data: FunctionLevelElement, i: number) => ({
    id: i,
    type: data.id,
    name: data.name || data.label, // data.name used for functions. data.label used for hierarchies.
});

const useAutocompleteFunctionsLevels = (): {
    functions: TElement[];
    hierarchies: TElement[];
    placeholderFunctions: string;
    placeholderHierarchy: string;
    status: RequestInfo;
} => {
    const intl = useIntl();
    const dispatch = useAppDispatch();
    const { data, status } = useAppSelector(getFunctionsLevels);

    const [functions, setFunctions] = useState<TElement[]>([]);
    const [hierarchies, setHierarchies] = useState<TElement[]>([]);

    const placeholderFunctions = intl.formatMessage({ id: "brief.functions.select.placeholder" });
    const placeholderHierarchy = intl.formatMessage({ id: "brief.hierarchy.select.placeholder" });

    // Fetch Roles
    useEffect(() => {
        if (isEmpty(data) && status !== "fetching") {
            dispatch(getFunctionsAndLevelsThunk());
        }

        if (!isEmpty(data)) {
            setFunctions(data.functions.map(convertFunctionHierarchyValue));
            setHierarchies(data.levels.map(convertFunctionHierarchyValue));
        }
    }, [data, dispatch, status]);

    return {
        functions,
        hierarchies,
        placeholderFunctions,
        placeholderHierarchy,
        status,
    };
};

export default useAutocompleteFunctionsLevels;
